import React, { Fragment } from 'react'
import { Grid, GridItem, Text } from '@chakra-ui/react'
import { isEmpty } from 'lodash'
import { TransferInitiationAssetWebDto } from '../../../api/types'

const OtherSecuritiesPreview = ({
  assets,
}: {
  assets?: TransferInitiationAssetWebDto[]
}) => {
  if (isEmpty(assets)) {
    return null
  } else {
    const titleSpan = 4
    const positionSpan = 2
    const identifierSpan = 4
    const amountSpan = 2
    const assetTypeSpan = 3
    const fillerSpan = 6 // Should bring totalColumnSpan up to 21 for form consistency
    const totalColumnSpan =
      titleSpan +
      positionSpan +
      identifierSpan +
      amountSpan +
      assetTypeSpan +
      fillerSpan

    return (
      <Grid
        borderBottom="1px solid gray"
        gridGap={4}
        padding={4}
        templateRows={`repeat(${assets?.length}, fit-content 1fr)`}
        templateColumns={`repeat(${totalColumnSpan}, 1fr)`}
      >
        <GridItem colSpan={titleSpan} rowSpan={assets?.length! + 1}>
          <Text fontWeight="semibold">Other Securities</Text>
        </GridItem>
        <GridItem colSpan={positionSpan}>
          <Text fontWeight="semibold">Position*</Text>
        </GridItem>
        <GridItem colSpan={identifierSpan}>
          <Text fontWeight="semibold">Identifier*</Text>
        </GridItem>
        <GridItem colSpan={amountSpan} justifySelf="end">
          <Text fontWeight="semibold">Quantity*</Text>
        </GridItem>
        <GridItem colSpan={assetTypeSpan + fillerSpan}>
          <Text fontWeight="semibold">Type*</Text>
        </GridItem>
        {assets?.map(
          ({
            rowId,
            isShort,
            identifier,
            amount,
            assetType,
          }: TransferInitiationAssetWebDto) => {
            let isShortToString: string = ''
            if (isShort === undefined) {
              isShortToString = ''
            } else if (isShort) {
              isShortToString = 'Short'
            } else if (!isShort) {
              isShortToString = 'Long'
            }

            return (
              <Fragment key={rowId}>
                <GridItem colSpan={positionSpan}>
                  <Text data-testid="assets-isShort-preview">
                    {isShortToString}
                  </Text>
                </GridItem>
                <GridItem colSpan={identifierSpan}>
                  <Text>{identifier}</Text>
                </GridItem>
                <GridItem colSpan={amountSpan} textAlign="right">
                  <Text>{amount}</Text>
                </GridItem>
                <GridItem colSpan={assetTypeSpan + fillerSpan}>
                  <Text>{assetType === 'SYMBOL' ? 'Symbol' : assetType}</Text>
                </GridItem>
              </Fragment>
            )
          }
        )}
      </Grid>
    )
  }
}

export default OtherSecuritiesPreview
